import * as React from 'react';
import { IconProps } from '../types';

const IcCashierVoided = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        d="M12.5 3a8.967 8.967 0 0 0-6.523 2.818c-.012.01-.027.014-.038.025-.017.017-.023.04-.04.059A8.958 8.958 0 0 0 3.5 12c0 4.963 4.037 9 9 9 4.962 0 9-4.037 9-9 0-4.962-4.038-9-9-9Zm-7.55 9c0-1.718.584-3.298 1.554-4.569l10.563 10.565a7.5 7.5 0 0 1-4.567 1.553c-4.163 0-7.55-3.387-7.55-7.55Zm13.182 5.009L7.49 6.368A7.51 7.51 0 0 1 12.5 4.45c4.162 0 7.55 3.387 7.55 7.55a7.51 7.51 0 0 1-1.918 5.009Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M3.5 3h18v18h-18z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcCashierVoided;
